import { paths } from 'src/routes/paths';

export const buildAdsDeepLink = ({ countryCode, domain, searchTerm, brandInfringement }: {
    countryCode?: string | null; domain: string; searchTerm?: string; brandInfringement?: boolean;
}): string => {
    const params = new URLSearchParams();
    if (countryCode) params.set('country', countryCode);
    if (domain) params.set('domain', domain);
    if (searchTerm) params.set('search_term', searchTerm);
    // Turns on the Ads page "Brand Infringement" filter (brandsPLA marker) so the
    // landing page only shows infringing ads, like the drawer checkbox does.
    if (brandInfringement) params.set('brand_infringement', '1');
    return `${paths.dash.visibilityAds}?${params.toString()}`;
};
